import {Component, Input, OnInit} from '@angular/core';
import {FilterInterface} from "../../../../../search/search-list/filters/filter-block/filter-item/filter-interface";
import {TranslateService} from "../../../../translate.service";
import {Filter} from "../../../../../search/search-list/filters/filter-block/filter-item/filter";
import {HtmlUtilsService} from "../../../../../html-utils/html-utils.service";
import {FilterSearch} from "../../../../../search/search-list/filter-search";
import {RangeEvent} from "../../../../../plots/chart/range-event";
import {FilterBaseComponent} from "../../../../../search/search-list/filters/filter-block/filter-base/filter-base.component";
import {FacetService} from "../../facet.service";
import {isNumber} from '@ng-bootstrap/ng-bootstrap/util/util';

@Component({
  selector: 'app-facet-range',
  templateUrl: './facet-range.component.html',
  styleUrls: ['./facet-range.component.scss']
})
export class FacetRangeComponent extends FilterBaseComponent implements OnInit {

  minValue: number;

  maxValue: number;

  fromValue: number;

  toValue: number;

  dataSet: FilterInterface[] = [];

  empty = false;

  htmlUtils: HtmlUtilsService;

  @Input() blockId: string;

  constructor(protected facetService: FacetService,
              htmlUtils: HtmlUtilsService,
              private translateService: TranslateService) {
    super();
    this.htmlUtils = htmlUtils;
  }

  isSimpleFilterAllowed(): boolean {
    return false;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.empty = !this.filterBlock.filters || this.filterBlock.filters.length === 0;
    const parsedRangeKeys = this.filterBlock.filters.map(filter => Number(filter.value));

    this.maxValue = Math.max(...parsedRangeKeys);
    this.minValue = Math.min(...parsedRangeKeys);

    let rangeFrom;
    let rangeTo;

    const rangeFilter = this.facetService.rangeFilters.get(this.filterBlock.filterConfig.name);
    if (rangeFilter) {
      rangeFrom = rangeFilter.rangeFrom;
      rangeTo = rangeFilter.rangeTo;
      this.fromValue = rangeFilter.rangeFrom;
      this.toValue = rangeFilter.rangeTo;
    } else {
      rangeFrom = this.minValue;
      rangeTo = this.maxValue;
    }
    this.prepareDataSet(rangeFrom, rangeTo);
  }

  doRefresh() {
    //TODO create working refresh
  }

  refreshRange() {
    let range;
    if (isNumber(this.fromValue) && isNumber(this.toValue)) {
      range = this.fromValue + '~' + this.toValue;
    } else if (this.fromValue) {
      range = this.fromValue + '~';
    } else if (this.toValue) {
      range = '~' + this.toValue;
    }
    this.facetService.appendRangeFilter(new FilterSearch({
      field: this.filterBlock.filterConfig.name,
      value: range,
      selected: true,
      range: true
    }));
    this.facetService.navigateByFilters();// button Odśwież
  }

  updateDates(range: RangeEvent) {
    this.fromValue = range.dateFrom;
    this.toValue = range.dateTo;
  }

  zoomIn() {
    this.prepareInitValues();
    this.fromValue = this.fromValue + 5;
    this.toValue = this.toValue - 5;
    this.prepareDataSet(this.fromValue, this.toValue);
  }

  zoomOut() {
    this.prepareInitValues();
    this.fromValue = this.fromValue - 5;
    this.toValue = this.toValue + 5;
    this.prepareDataSet(this.fromValue, this.toValue);
  }

  goLeft() {
    this.prepareInitValues();
    this.fromValue = this.fromValue - 20;
    this.toValue = this.toValue - 20;
    this.prepareDataSet(this.fromValue, this.toValue);
  }

  goRight() {
    this.prepareInitValues();
    this.fromValue = this.fromValue + 20;
    this.toValue = this.toValue + 20;
    this.prepareDataSet(this.fromValue, this.toValue);
  }

  resetRange() {
    this.fromValue = null;
    this.toValue = null;
    this.facetService.cleanGroup(this.filterBlock.filterConfig.name);
    //this.facetService.navigateByFilters();// button Resetuj
  }

  fromLabel() {
    return this.translateService.translate(this.filterBlock.filterConfig.translation)+' '+this.translateService.translate('FilterRange.from');
  }

  toLabel() {
    return this.translateService.translate(this.filterBlock.filterConfig.translation)+' '+this.translateService.translate('FilterRange.to');
  }

  private prepareDataSet(rangeFrom, rangeTo) {
    const tempDataFrom = isNumber(rangeFrom) ? rangeFrom : this.minValue;
    const tempDataTo = isNumber(rangeTo) ? rangeTo : this.maxValue;
    this.dataSet = this.filterBlock.filters.filter(ds => +ds.value >= tempDataFrom && +ds.value <= tempDataTo);
    if (!this.dataSet.find(ds => ds.value === tempDataFrom + '')) {
      this.dataSet.push(new Filter({value: tempDataFrom + '', count: 0}));
    }
    if (!this.dataSet.find(ds => ds.value === tempDataTo + '')) {
      this.dataSet.push(new Filter({value: tempDataTo + '', count: 0}));
    }
  }

  private dataInRange(dateFrom: number, dateTo: number){
    return this.filterBlock.filters.filter(ds => +ds.value >= dateFrom && +ds.value <= dateTo).length > 0;
  }

  private prepareInitValues() {
    if (!isNumber(this.fromValue)) {
      this.fromValue = this.minValue;
    }
    if (!isNumber(this.toValue)) {
      this.toValue = this.maxValue;
    }
    if (!isNumber(this.fromValue)) {
      this.fromValue = 0;
    }
    if (!isNumber(this.toValue)) {
      this.toValue = 0;
    }
  }

}
